import Vue from "vue";
import { i18n } from "@/i18n";
import { MOBILE_LAYOUT_QUERY } from "@/mixins/mobileLayoutMixin";
import GuidedTour from "./GuidedTour.vue";

/**
 * Recorridos guiados (tutoriales interactivos). Un recorrido es una lista de pasos:
 *
 *   {
 *     id: "dashboard-widgets",
 *     steps: [{
 *       target: '[data-tour="widgets-button"]',  // selector o función que devuelve el elemento; sin target = tarjeta al centro
 *       titleKey: "…", bodyKey: "…",              // claves i18n (se traducen con $tn: idioma de avisos)
 *       bodyMobileKey: "…",                       // opcional: otro texto en el teléfono
 *       advanceOn: "click",                       // opcional: avanza cuando el usuario hace click en el elemento
 *       interactive: true,                        // opcional: el elemento se puede usar (sin avanzar solo)
 *       only: "desktop" | "mobile",               // opcional: el paso solo existe ahí
 *       placement: "bottom" | "top" | "left" | "right",  // opcional: preferencia
 *     }],
 *   }
 *
 * El componente se monta en <body> la primera vez que se usa: no hay que agregarlo a
 * ninguna pantalla ni a App.vue.
 */

export const tourState = Vue.observable({ tour: null, index: 0 });

let host = null;
let callbacks = {};

function ensureHost() {
  if (host) return;
  const Ctor = Vue.extend(GuidedTour);
  host = new Ctor({ i18n });
  host.$mount();
  document.body.appendChild(host.$el);
}

export function isMobileViewport() {
  return typeof window !== "undefined" && window.matchMedia && window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
}

/**
 * Arranca un recorrido. `onFinish` se llama al llegar al final y `onClose` al cerrarlo
 * antes (Saltar / Esc).
 */
export function startTour(tour, { onFinish, onClose } = {}) {
  if (!tour || !Array.isArray(tour.steps)) return;
  const mobile = isMobileViewport();
  const steps = tour.steps.filter((s) => !s.only || (s.only === "mobile") === mobile);
  if (!steps.length) return;
  ensureHost();
  callbacks = { onFinish, onClose };
  tourState.index = 0;
  tourState.tour = { ...tour, steps, mobile };
}

export function isTourRunning() {
  return !!tourState.tour;
}

export function goToStep(index) {
  const t = tourState.tour;
  if (!t) return;
  if (index >= t.steps.length) {
    endTour("finish");
    return;
  }
  tourState.index = Math.max(0, index);
}

export function endTour(reason = "close") {
  if (!tourState.tour) return;
  const { onFinish, onClose } = callbacks;
  callbacks = {};
  tourState.tour = null;
  tourState.index = 0;
  const cb = reason === "finish" ? onFinish : onClose;
  if (typeof cb === "function") cb();
}
